export default "__VITE_ASSET__67922418__"